import React, { Fragment } from 'react';
import { TableProps } from '../../utils/models';

import TableHeader from './tableHeader';
import TableBody from './tableBody';

const Table: React.FC<TableProps> = (props): JSX.Element => {
	return (
		<Fragment>
			<table className="table">
				<TableHeader
					columns={props.columns}
					sortColumn={props.sortColumn}
					onSort={props.onSort}
				/>

				<TableBody
					columns={props.columns}
					loading={props.isFetching}
					data={props.data}
				/>
			</table>
		</Fragment>
	);
};

export default Table;
